/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/": {
    get: operations["Get"];
  };
  "/affiliate": {
    /** Insert into `statistics.referrals_visits`, `statistics.affiliates_visits` */
    get: operations["GetAffiliate"];
  };
  "/api/t/h": {
    /** Insert into `statistics.visits` */
    get: operations["GetApiTH"];
  };
  "/api/tracker/affiliate": {
    /** Insert into `statistics.referrals_visits`, `statistics.affiliates_visits` */
    get: operations["GetApiTrackerAffiliate"];
  };
  "/api/tracker/affiliate/action": {
    /** Insert into `logs.affiliate_actions` */
    post: operations["PostApiTrackerAffiliateAction"];
  };
  "/api/tracker/hit": {
    /** Insert into `statistics.visits` */
    get: operations["GetApiTrackerHit"];
  };
  "/api/tracker/referral": {
    /** Insert into `statistics.referrals_visits` */
    get: operations["GetApiTrackerReferral"];
  };
  "/api/tracker/retention/hit": {
    /** Insert into `statistics.retention_hits` */
    get: operations["GetApiTrackerRetentionHit"];
  };
  "/hit": {
    /** Insert into `statistics.visits` */
    get: operations["GetHit"];
  };
  "/referral": {
    /** Insert into `statistics.referrals_visits` */
    get: operations["GetReferral"];
  };
  "/reg": {
    /** Insert into `public.external_users_promo_regs` */
    get: operations["GetReg"];
  };
  "/retention/hit": {
    /** Insert into `statistics.retention_hits` */
    get: operations["GetRetentionHit"];
  };
}

export interface components {
  schemas: {
    "controller.affiliateActionBody": {
      name?: number;
      params?: {
        retentionTrack?: string;
      };
    };
    "web.ActionResultContent": {
      status?: boolean;
    };
  };
}

export interface operations {
  Get: {
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.referrals_visits`, `statistics.affiliates_visits` */
  GetAffiliate: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id?: number;
        /** Aff track */
        aff_track?: string;
        /** Site ID */
        site_id?: number;
        /** Source */
        source?: string;
        /** Keyword */
        keyword?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.visits` */
  GetApiTH: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id: number;
        /** Platform brand ID */
        brand_id?: number;
        /** Aff track */
        aff_track?: string;
        /** Referrer */
        referrer?: string;
        /** Aff model */
        aff_model?: string;
        /** Landing Url */
        landing_url?: string;
        /** Promo entity ID */
        promo_entity_id?: number;
        /** Promo entity type */
        promo_type?: string;
        /** Advertiser ID */
        advertiser_id?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.referrals_visits`, `statistics.affiliates_visits` */
  GetApiTrackerAffiliate: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id?: number;
        /** Aff track */
        aff_track?: string;
        /** Site ID */
        site_id?: number;
        /** Source */
        source?: string;
        /** Keyword */
        keyword?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `logs.affiliate_actions` */
  PostApiTrackerAffiliateAction: {
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
    /** Body */
    requestBody: {
      content: {
        "application/json": components["schemas"]["controller.affiliateActionBody"];
      };
    };
  };
  /** Insert into `statistics.visits` */
  GetApiTrackerHit: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id: number;
        /** Platform brand ID */
        brand_id?: number;
        /** Aff track */
        aff_track?: string;
        /** Referrer */
        referrer?: string;
        /** Aff model */
        aff_model?: string;
        /** Landing Url */
        landing_url?: string;
        /** Promo entity ID */
        promo_entity_id?: number;
        /** Promo entity type */
        promo_type?: string;
        /** Advertiser ID */
        advertiser_id?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.referrals_visits` */
  GetApiTrackerReferral: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id: number;
        /** Aff track */
        aff_track?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.retention_hits` */
  GetApiTrackerRetentionHit: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id: number;
        /** Retention track */
        track: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.visits` */
  GetHit: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id: number;
        /** Platform brand ID */
        brand_id?: number;
        /** Aff track */
        aff_track?: string;
        /** Referrer */
        referrer?: string;
        /** Aff model */
        aff_model?: string;
        /** Landing Url */
        landing_url?: string;
        /** Promo entity ID */
        promo_entity_id?: number;
        /** Promo entity type */
        promo_type?: string;
        /** Advertiser ID */
        advertiser_id?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.referrals_visits` */
  GetReferral: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id: number;
        /** Aff track */
        aff_track?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `public.external_users_promo_regs` */
  GetReg: {
    parameters: {
      query: {
        /** Trader ID */
        trader_id: number;
        /** Promo entity ID */
        promo_entity_id: number;
        /** Promo type */
        promo_type: "banner";
        /** Landing url */
        landing_url: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
  /** Insert into `statistics.retention_hits` */
  GetRetentionHit: {
    parameters: {
      query: {
        /** Aff ID */
        aff_id: number;
        /** Retention track */
        track: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": components["schemas"]["web.ActionResultContent"];
        };
      };
    };
  };
}

export interface external {}

export enum ApiPaths {
  Get = "/",
  GetAffiliate = "/affiliate",
  GetApiTH = "/api/t/h",
  GetApiTrackerAffiliate = "/api/tracker/affiliate",
  PostApiTrackerAffiliateAction = "/api/tracker/affiliate/action",
  GetApiTrackerHit = "/api/tracker/hit",
  GetApiTrackerReferral = "/api/tracker/referral",
  GetApiTrackerRetentionHit = "/api/tracker/retention/hit",
  GetHit = "/hit",
  GetReferral = "/referral",
  GetReg = "/reg",
  GetRetentionHit = "/retention/hit",
}
